import * as React from 'react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/admin-dashboard';

type Props = {
  onClose: () => void;
  open?: boolean;
};

export const GradebookExportSuccessModal: React.FC<Props> = ({ onClose, open = true }) => {
  const { HeadingGroup, Content, Actions } = Dialog;
  return (
    <Dialog onClose={onClose} open={open} variant="standard" data-testid="gradebook-export-success-modal">
      <HeadingGroup>{_t('Your grades are being prepared for export.')}</HeadingGroup>
      <Content>
        <Typography2 component="p" variant="bodyPrimary">
          {_t(
            'Your gradebook will be generated as a CSV file.  You will receive an email that contains the download link when it is ready. This process can take up to 15 minutes.  Thank you for your patience.'
          )}
        </Typography2>
      </Content>
      <Actions>
        <Button variant="primary" onClick={onClose}>
          {_t('Okay')}
        </Button>
      </Actions>
    </Dialog>
  );
};
